export { default } from "./property-type-dekstop";